export default __webpack_public_path__ + "static/media/ExcellentProduct.fa8c0261.jpg";